<div class="wm-view wm-l-issuereporter-container webmate-default-theme">
  <div class="wm-topbar">
    <span class="header">Report Issue for {{ contextLabel }}</span>
  </div>
  <div class="issuereporter-wrapper">
    <div class="issuereporter form">
    <div class="form-section">
      <div class="form-section-info">
        <h4>Issue Reporter</h4>
        <div class="description">Choose where the issue should be created.</div>
      </div>
      <div class="form-section-content flex">
        <div class="form-item">
          <h4 class="form-label required">Integration</h4>
          <div class="form-item-content">
            <div class="project-select-row">
              <p-dropdown class="wide-dropdown"
                          [options]="issueReporterOptions"
                          [optionLabel]="'label'"
                          [optionValue]="'value'"
                          [disabled]="loadingIssueReporters || issueReporterOptions.length === 0"
                          [ngModel]="selectedIssueReporterId"
                          [ngModelOptions]="{standalone: true}"
                          (onChange)="onReporterChange($event.value)"
                          [placeholder]="loadingIssueReporters ? 'Loading integrations...' : 'Select issue reporter'">
              </p-dropdown>
              @if (loadingIssueReporters) {
                <p-progressSpinner class="inline-spinner"></p-progressSpinner>
              }
            </div>
            @if (!loadingIssueReporters && issueReporterOptions.length === 0) {
              <div class="small-hint">No issue reporters available.</div>
            }
          </div>
        </div>
      </div>
    </div>

    @if (!!selectedIssueReporterId) {
      <div class="form-section">
        <div class="form-section-info">
          <h4>Project & Issue Type</h4>
          <div class="description">Select the target project and issue type.</div>
        </div>
        <div class="form-section-content flex">
          <div class="form-item">
            <h4 class="form-label required">Project</h4>
            <div class="form-item-content">
              <div class="project-select-row">
                <p-dropdown class="wide-dropdown"
                            [options]="jiraProjectOptions"
                            [optionLabel]="'label'"
                            [optionValue]="'value'"
                            [disabled]="loadingJiraProjects"
                            [ngModel]="selectedJiraProjectId"
                            [ngModelOptions]="{standalone: true}"
                            (onChange)="onJiraProjectChange($event.value)"
                            [placeholder]="loadingJiraProjects ? 'Loading projects...' : 'Select project'">
                </p-dropdown>
                @if (loadingJiraProjects) {
                  <p-progressSpinner class="inline-spinner"></p-progressSpinner>
                }
              </div>
            </div>
          </div>
          <div class="form-item">
            <h4 class="form-label required">Issue Type</h4>
            <div class="form-item-content">
              <div class="project-select-row">
                <p-dropdown class="wide-dropdown"
                            [options]="issueTypeOptions"
                            [optionLabel]="'label'"
                            [optionValue]="'value'"
                            [disabled]="!selectedJiraProjectId || loadingJiraProjects"
                            [ngModel]="selectedIssueTypeId"
                            [ngModelOptions]="{standalone: true}"
                            (onChange)="onIssueTypeChange($event.value)"
                            [placeholder]="loadingJiraProjects ? 'Loading issue types...' : (!selectedJiraProjectId ? 'Select project first' : 'Select issue type')">
                </p-dropdown>
                @if (loadingJiraProjects) {
                  <p-progressSpinner class="inline-spinner"></p-progressSpinner>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (!!selectedJiraProjectId && !!selectedIssueTypeId && (loadingFields || loadingDefaults)) {
      <div class="loading-spinner">
        <p-progressSpinner></p-progressSpinner>
        <div>Loading issue fields...</div>
      </div>
    }

    @if (!!selectedJiraProjectId && !!selectedIssueTypeId && !loadingFields && !loadingDefaults && reporterFields.length === 0) {
      <div class="no-fields-message">
        Issue creation is not supported for this project and issue type.
      </div>
    }

    @if (!!selectedJiraProjectId && !!selectedIssueTypeId && !loadingFields && !loadingDefaults && !!form && reporterFields.length > 0) {
      <div class="form-section" [formGroup]="form">
        <div class="form-section-info">
          <h4>Issue Fields</h4>
          <div class="description">Provide the details for the new issue.</div>
        </div>
        <div class="form-section-content flex ui-fluid">
          <div class="issue-fields-grid">
            @for (field of formFields; track field.name) {
              <div class="form-item">
                <h4 class="form-label" [class.required]="field.required">
                  {{ field.optDisplayName || field.name }}
                </h4>
                <div class="form-item-content p-field">
                  @if (isStringListField(field)) {
                    <div class="labels-field-wrapper">
                      <wm-multiselect-with-custom-input
                        [fieldId]="field.name"
                        [field]="field"
                        [control]="form.get(field.name)!">
                      </wm-multiselect-with-custom-input>
                    </div>
                  }
                  @if (isDropdownField(field)) {
                    <p-dropdown [formControlName]="field.name" [options]="fieldOptions(field)" [filter]="true" [placeholder]="field.optDisplayName || field.name"></p-dropdown>
                  }
                  @if (isRichTextField(field)) {
                    <p-editor class="richtext-editor" [formControlName]="field.name" [style]="{'height':'240px'}"></p-editor>
                  }
                  @if (isNumberField(field)) {
                    <input [id]="field.name" type="number" pInputText [formControlName]="field.name" class="form-input"/>
                  }
                  @if (isDateField(field)) {
                    <p-date-picker [formControlName]="field.name" [showTime]="false" hourFormat="24" dateFormat="yy-mm-dd"></p-date-picker>
                  }
                  @if (isDateTimeField(field)) {
                    <p-date-picker [formControlName]="field.name" [showTime]="true" hourFormat="24" dateFormat="yy-mm-dd"></p-date-picker>
                  }
                  @if (isTextField(field)) {
                    <input [id]="field.name" type="text" pInputText [formControlName]="field.name" class="form-input"/>
                  }
                </div>
              </div>
            }

            @if (canContinueInJira()) {
              <div class="form-item continue-in-jira">
                <button pButton class="p-button-secondary" type="button" (click)="continueInJira()">
                  <fa-icon [icon]="faExternalLinkAlt"></fa-icon>
                  <span>Continue creating issue in Jira</span>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (!!selectedJiraProjectId && !!selectedIssueTypeId && !loadingFields && !loadingDefaults && !!form && supportsAttachments) {
      <div class="form-section attachment-section">
        <div class="form-section-info">
          <h4>Attachments</h4>
          <div class="description">Select which related artifacts or findings to attach.</div>
        </div>
        <div class="form-section-content flex">
          @if (attachments && attachments.length > 0) {
            <div class="attachment-list">
              @for (attachment of attachments; track attachment.key) {
                <div class="attachment-row">
                  <div class="info">
                    @let previewUrl = attachmentPreviewUrl(attachment);
                    @let previewIcon = attachmentPreviewIcon(attachment);
                    @if (previewUrl || previewIcon) {
                      <div class="preview" [class.placeholder]="!previewUrl">
                        @if (previewUrl) {
                          <img [src]="previewUrl" [alt]="attachment.displayName || 'Attachment preview'">
                        } @else {
                          <fa-icon [icon]="previewIcon" [fixedWidth]="true"></fa-icon>
                        }
                      </div>
                    }
                    <div class="text">
                      <div class="title">{{ attachmentDisplayName(attachment) }}</div>
                      <div class="meta">{{ attachmentTypeLabel(attachment) }}</div>
                    </div>
                  </div>
                  <p-checkbox [binary]="true" [(ngModel)]="selectedAttachments[attachment.key]" (onChange)="onAttachmentSelectionChange()" [ngModelOptions]="{standalone: true}"></p-checkbox>
                </div>
              }
            </div>
          } @else {
            <div class="no-attachments-message">No attachments available.</div>
          }
        </div>
      </div>
    }
    </div>

    <div class="submit-button-container">
      @if (!submittedIssueUrl) {
        <button class="submit-button" [disabled]="submitting || !form || form.invalid" (click)="submit()" pButton type="button">
          @if (!submitting) {
            <span>Submit</span>
          }
          @if (submitting) {
            <fa-icon icon="sync-alt" animation="spin" [fixedWidth]="true"></fa-icon>
          }
        </button>
      }
      @if (submittedIssueUrl) {
        <button class="submit-button" (click)="openIssueInJira()" pButton type="button">
          <fa-icon [icon]="faExternalLinkAlt" [fixedWidth]="true"></fa-icon>
          <span>View Issue in Jira</span>
        </button>
      }
    </div>
  </div>
</div>
